import React, { Component, Fragment } from 'react'
import {Container,Row,Col,Card} from 'react-bootstrap'
import Slider from './Slider'
import MegaMenu from './MegaMenu'
import HomeSlider from './HomeSlider'
import AppURL from '../../api/AppURL';
import axios from 'axios'



class HomeTop extends Component {



 constructor(){
          super();
          this.state ={
                MenuData:[],
               SliderData:[]
          }
     }

     componentDidMount(){
          axios.get(AppURL.AllCategoryDetails).then(response =>{ 
                this.setState({MenuData:response.data});

          }).catch(error=>{


          });

         axios.get(AppURL.AllSlider).then(response =>{ 
               this.setState({SliderData:response.data});

         }).catch(error=>{

         });


     }



     render() {
          return (
               <Fragment>
        <Container className="p-0 m-0 overflow-hidden" fluid={true}>
                         <Row>
                              {/* <Col lg={3} md={3} sm={12}>

                              
                              <MegaMenu data={this.state.MenuData} />
                              </Col> */}

                              <Col lg={12} md={12} sm={12}>
                              <Slider />
                             

<HomeSlider data={this.state.SliderData} />



                              </Col>
                         </Row>
                    </Container>
               </Fragment>
          )
     }
}

export default HomeTop